
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4870"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4870"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2k9uD", function(module, exports) {

$parcel$export(module.exports, "register", () => $1b14d023b9216840$export$6503ec6e8aabbaf, (v) => $1b14d023b9216840$export$6503ec6e8aabbaf = v);
var $1b14d023b9216840$export$6503ec6e8aabbaf;
var $1b14d023b9216840$export$f7ad0328861e2f03;
"use strict";
var $1b14d023b9216840$var$mapping = new Map();
function $1b14d023b9216840$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1b14d023b9216840$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1b14d023b9216840$var$resolve(id) {
    var resolved = $1b14d023b9216840$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1b14d023b9216840$export$6503ec6e8aabbaf = $1b14d023b9216840$var$register;
$1b14d023b9216840$export$f7ad0328861e2f03 = $1b14d023b9216840$var$resolve;

});

var $bd13c1d817ddb66b$exports = {};

(parcelRequire("2k9uD")).register(new URL("", import.meta.url).toString(), JSON.parse('["izUj7","index.0e22b778.js","9EQOo","binance.e8e8711e.png","58uBu","wallet-connect.adc1d7c5.png","aAKV5","metamask.3dc053f7.png","dZ6fk","coinbase.55ac22d5.webp","kowIw","trust.e6732b19.png","eClR4","zerion.fd1b79ca.png","4u0EK","rainbow.5cf7601c.png","bGlZP","uniswap.08f5b030.png","dd5wN","argent.2a9bc566.png","e8KcI","phantom.5e677aad.png","3fR37","okx.512858a0.png","g2KFJ","crypto.e660190f.png","byIp1","bitget.da063d1c.png","GZ5zS","robinhood.50f8de49.webp","jEaKt","tokenpocket.a61039cd.png","85WlQ","blockchain.20fdc75d.png","ac9f4","shield.93ee356a.png","iLW1R","circled-arrow.f4ab57f3.png"]'));


//# sourceMappingURL=index.runtime.b49abe36.js.map
